import { BasicRestrictionsApplier } from './impl/basic';

class CompositeRestrictionsApplier {
    /**
     * @returns {RestrictionsApplier[]}
     */
    get restrictors() {
        if (!this._restrictors) {
            this._restrictors = [new BasicRestrictionsApplier()];
        }

        return this._restrictors;
    }

    /**
     * @param {{billing: *}} subject
     * @param {*} target
     * @param {boolean} [lenient]
     * @returns {boolean}
     */
    apply(subject, target, lenient = false) {
        const billing = subject.billing || {};
        let applied = false;

        for (const restrictor of this.restrictors) {
            if (restrictor.applicable(billing, lenient)) {
                applied |= restrictor.apply(target);
            }
        }

        return applied;
    }

    /**
     * @param {{billing: *}} subject Workspace to process
     * @param {boolean} [lenient] Should be graceful period for failed payment be taken into account
     * @returns {boolean} <code>true</code> if any restriction was applied, false otherwise
     */
    applyTo(subject, lenient) {
        return this.apply(subject, subject, lenient);
    }
}

export const restrictionsApplier = new CompositeRestrictionsApplier();
